import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import { makeStyles } from "@material-ui/core/styles";
import QuickCheck from "./QuickCheck";
import ResultDownloader from "./ResultDownloader";

import fb from "./ConfiguredFirebase";

const theme = createMuiTheme({
  typography: {
    fontFamily: `"Titillium Web", sans-serif`,
    fontSize: 16,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
  palette: {
    text: {
      primary: "#707070",
      secondary: "#64b42f",
    },
    primary: {
      main: "#707070",
    },
    secondary: {
      main: "#64b42f",
    },
  },
});

const useStyles = makeStyles({
  grid: {
    width: "100%",
    marginLeft: "40px",
    marginRight: "40px",
  },
  header: {
    paddingTop: "20px",
    paddingBottom: "20px",
  },
  title: {
    paddingLeft: "40px",
    paddingRight: "40px",
  },
  spacer: {
    marginBottom: "0px",
  },
  progress: {
    marginTop: "20px",
    paddingTop: "10px",
  },
  emailContainer: {
    marginTop: "40px",
    marginBottom: "40px",
  },
  emailHeader: {
    marginBottom: "20px",
  },
  emailField: {
    width: "400px",
  },
  loading: {
    marginTop: "40px",
  },
});

function ValidateQuestions(questions) {
  let errors = [];
  if (questions.length === 0) {
    errors.push("No data found - got empty array! Are you offline?");
  }
  let requiredBoolFields = ["singleAnswer"];
  let requiredArrayFields = ["choices", "weights"];
  let requiredStringFields = ["description", "category"];

  questions.forEach((question) => {
    requiredBoolFields.forEach((fieldName) => {
      if (!question.hasOwnProperty(fieldName)) {
        errors.push(
          `Question ${question.id}: field ${fieldName} is missing, expected boolean!`
        );
      } else if (typeof question[fieldName] !== "boolean") {
        errors.push(
          `Question ${question.id}: field ${fieldName} is not boolean!`
        );
      }
    });
    requiredStringFields.forEach((fieldName) => {
      if (!question.hasOwnProperty(fieldName)) {
        errors.push(
          `Question ${question.id}: field ${fieldName} is missing, expected string!`
        );
      } else if (typeof question[fieldName] !== "string") {
        errors.push(
          `Question ${question.id}: field ${fieldName} is not string!`
        );
      } else if (question[fieldName].trim() === "") {
        errors.push(
          `Question ${question.id}: field ${fieldName} contains empty string!`
        );
      }
    });
    requiredArrayFields.forEach((fieldName) => {
      if (!question.hasOwnProperty(fieldName)) {
        errors.push(
          `Question ${question.id}: field ${fieldName} is missing, expected array!`
        );
      } else if (!Array.isArray(question[fieldName])) {
        errors.push(
          `Question ${question.id}: field ${fieldName} is not an array!`
        );
      } else if (question.length === 0) {
        errors.push(
          `Question ${question.id}: field ${fieldName} is of length zero!`
        );
      }
    });
    if (
      question.hasOwnProperty("choices") &&
      question.hasOwnProperty("weights")
    ) {
      if (question.choices.length !== question.weights.length) {
        errors.push(
          `Question ${question.id}: choices array has length ${question.choices.length}, weights array has length ${question.weights.length}. Excpected equal length!`
        );
      }
      if (question.weights.some((weight) => typeof weight !== "number")) {
        errors.push(
          `Question ${question.id}: weights array does not contain numbers only!`
        );
      }
    }
  });
  return errors;
}

function GetData(category) {
  if (category) {
    return fb.firestore
      .collection("Fragen")
      .where("category", "==", category)
      .get();
  } else {
    return fb.firestore.collection("Fragen").get();
  }
}

function AppLogic({ category }) {
  const classes = useStyles();
  const [errors, setErrors] = useState({ exists: false });
  const [loading, setLoading] = useState(true);
  const [questions, setQuestions] = useState([]);
  useEffect(() => {
    GetData(category)
      .then((docs) => {
        let questions = [];
        docs.forEach((doc) => {
          questions.push({ ...doc.data(), id: doc.id });
        });
        questions.sort(function (a, b) {
          if (a.sequence < b.sequence) {
            return -1;
          }
          if (a.sequence > b.sequence) {
            return 1;
          }
          return 0;
        });
        if (questions.length === 0) {
        }
        questions.forEach((question) => {
          if (!Array.isArray(question.choices)) {
          }
        });
        let errors = ValidateQuestions(questions);
        if (errors.length > 0) {
          setErrors({ exists: true, messages: errors });
        } else {
          setQuestions(questions); //.slice(0,2)
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error(error.status);
        setErrors({ exists: false, messages: [error.status] });
        setLoading(false);
      });
  }, [category]);

  if (errors.exists) {
    return (
      <Grid>
        {errors.messages.map((message) => (
          <Typography color="textPrimary">{message}</Typography>
        ))}
      </Grid>
    );
  }
  if (loading) {
    return (
      <Grid
        container
        xs={12}
        direction="column"
        alignContent="center"
        justify="center"
        className={classes.loading}
      >
        <CircularProgress color="secondary" />
      </Grid>
    );
  }
  if (questions.length === 0) {
    return <Typography color="textPrimary">No data found!</Typography>;
  } else {
    return <QuickCheck questions={questions} category={category} />;
  }
}

function Main({ category = "" }) {
  const classes = useStyles();
  return (
    <>
      <AppLogic category={category} />
    </>
  );
}

function App() {
  const classes = useStyles();
  return (
    <ThemeProvider theme={theme}>
      <Grid
        container
        direction="column"
        className={classes.header}
        alignContent="center"
      >
        <Grid item>
          <img src={require("./advacon_logo_01.png")} width={400} alt="logo" />
        </Grid>
        <Typography color="textPrimary" variant="h4" className={classes.title}>
          Quick Check
        </Typography>
      </Grid>
      <Divider className={classes.spacer} />
      <BrowserRouter>
        <Switch>
          <Route exact path="/ResultDownload" component={ResultDownloader} />
          <Route exact path="/" component={Main} />
          <Route
            exact
            path="/:id"
            component={({ match }) => <Main category={match.params.id} />}
          />
        </Switch>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
